import {
  fontSizeVars,
  fontWeightVars,
  lineHeightVars,
} from '@tundr/ds-foundations';
import { style, styleVariants } from '@vanilla-extract/css';
import { nToPx, shine, themeVars, toBorder } from '@tundr/theme';
import { InputSizeVariant, InputWidthVariant } from './';

export const inputContainerClass = style({
  display: 'flex',
  flexDirection: 'column',
});

export const inputWrapperClass = style({
  position: 'relative',
});

export const invalidInputClass = style({
  border: toBorder(themeVars.colors.status.error.x100),

  selectors: {
    '&:focus': {
      border: toBorder(themeVars.colors.status.error.x100),
    },
  },
});

export const inputClass = style([
  {
    width: '100%',
    fontSize: themeVars.font.size.textLg,
    color: themeVars.colors.neutrals.black100,
    backgroundColor: themeVars.colors.neutrals.white,
    border: toBorder(themeVars.colors.neutrals.grey50),
    borderRadius: themeVars.radius.sm,
    outline: 'none',
    padding: nToPx(themeVars.space.x2, themeVars.space.x3),
    height: 48,
    lineHeight: 1.5,

    selectors: {
      '&::placeholder': {
        color: themeVars.colors.neutrals.grey60,
      },

      [`&:focus&:not(${invalidInputClass})`]: {
        border: toBorder(themeVars.colors.neutrals.grey70),
      },

      '&:disabled': {
        color: themeVars.colors.neutrals.grey60,
        backgroundColor: themeVars.colors.neutrals.grey30,
        border: toBorder(themeVars.colors.neutrals.grey50),
      },
    },
  },
]);

export const inputWithLeftIconClass = style({
  paddingLeft: themeVars.space.x9,
});

export const inputWithRightIconClass = style({
  paddingRight: themeVars.space.x9,
});

export const inputWidthClass = styleVariants({
  [InputWidthVariant.AUTO]: {
    width: 250,
    maxWidth: 250,
  },
  [InputWidthVariant.FULL]: {
    width: '100%',
  },
  [InputWidthVariant.SMALL]: {
    width: 140,
    maxWidth: 140,
  },
  [InputWidthVariant.MIN]: {
    width: 'fit-content',
    maxWidth: 'none',
  },
});

export const inputSizeClass = styleVariants({
  [InputSizeVariant.SMALL]: {
    fontSize: themeVars.font.size.textMd,
    minHeight: 32,
  },
  [InputSizeVariant.DEFAULT]: {
    fontSize: themeVars.font.size.textLg,
    minHeight: 48,
  },
});

export const warningInputClass = style({
  border: toBorder(themeVars.colors.status.warning.x100),

  selectors: {
    '&:focus': {
      outline: toBorder(themeVars.colors.status.warning.x100),
    },
  },
});

//TODO(it should be fixed with flex and reserved space for right and left)
export const rightSlotClass = style({
  position: 'absolute',
  top: 9,
  right: 10,
  zIndex: themeVars.zIndex.content + 1,
});

export const leftSlotClass = style({
  position: 'absolute',
  top: 9,
  left: 10,
  zIndex: themeVars.zIndex.content + 1,
});

export const readonlyInputClass = style({
  backgroundColor: themeVars.colors.neutrals.grey40,
  color: themeVars.colors.neutrals.grey60,
  cursor: 'not-allowed',

  selectors: {
    '&:focus': {
      outline: 'none',
    },
  },
});

export const clearInputIconClass = style({
  fontSize: themeVars.font.size.iconMd,
  position: 'relative',
  top: 3,
});

export const inputLoaderClass = style([
  shine,
  {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    backgroundSize: '200% 100%',
    backgroundImage: `linear-gradient(90deg, ${themeVars.colors.neutrals.grey40} 0px, ${themeVars.colors.neutrals.grey30} 30%, ${themeVars.colors.neutrals.white} 50%,${themeVars.colors.neutrals.grey40} 100%)`,
    opacity: 0.7,
    border: toBorder(themeVars.colors.neutrals.grey70),
    borderRadius: themeVars.radius.md,
    zIndex: themeVars.zIndex.content + 2,
    outline: 'none',
  },
]);

export const inputHeaderClass = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: themeVars.space.x2,
});

export const inputLabelClass = style({
  fontSize: fontSizeVars.body.body1,
  fontWeight: fontWeightVars.bold,
  lineHeight: lineHeightVars.body.body1,
});

export const notRequiredClass = style({
  marginLeft: themeVars.space.x2,
  fontSize: themeVars.font.size.textSm,
  fontStyle: 'italic',
});

export const errorClass = style({
  fontSize: themeVars.font.size.textSm,
  marginTop: themeVars.space.x1,
  marginLeft: themeVars.space.x2,
  color: themeVars.colors.status.error.x100,
});

export const warningClass = style({
  fontSize: themeVars.font.size.textSm,
  marginTop: themeVars.space.x1,
  marginLeft: themeVars.space.x2,
  color: themeVars.colors.status.warning.x100,
});
